const DebugConstants = {
    ComponentDidMount: '11',
    ComponentWillUnMount: '12',
    ComponentDidUpdate: '13',
    FetchInProgress: '14',
    CardDetailsPresent: '15',
    FetchInitiated: '16',
    NotUpdatingCardDetailsAsItAlreadyPresent: '17',
    FetchSuccess: '18',
    CardId: '19',
    ItemId: '110',
    FetchError: '111',
    FetchException: '112',
    RenderCard: '113',
    NoCard: '114',
    ShowMessage: '115',
    UpdateOnItem: '116',
    UpdateLoadingState: '117',
    FinishLoading: '118',
    Render: '119',
};

export default DebugConstants;
